/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolKitchenIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-kitchen"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.13 7.9Q9.13 7.9 9.4 7.9Q9.68 7.9 10.06 7.51Q10.45 7.13 10.45 6.58L10.45 5.97Q10.45 5.42 10.06 5.04Q9.68 4.65 9.13 4.65Q8.57 4.65 8.19 5.04Q7.8 5.42 7.8 5.97L7.8 6.58Q7.8 7.13 8.19 7.51Q8.57 7.9 9.13 7.9ZM9.13 17.65Q9.13 17.65 9.4 17.65Q9.68 17.65 10.06 17.26Q10.45 16.88 10.45 16.32L10.45 13.47Q10.45 12.93 10.06 12.54Q9.68 12.15 9.13 12.15Q8.57 12.15 8.19 12.54Q7.8 12.93 7.8 13.47L7.8 16.32Q7.8 16.88 8.19 17.26Q8.57 17.65 9.13 17.65ZM5.9 22.8Q4.78 22.8 4.01 22.04Q3.25 21.27 3.25 20.15L3.25 11.03L20.75 11.03L20.75 20.15Q20.75 21.27 19.99 22.04Q19.23 22.8 18.1 22.8ZM3.25 9.03L3.25 3.85Q3.25 2.73 4.01 1.96Q4.78 1.2 5.9 1.2L18.1 1.2Q19.23 1.2 19.99 1.96Q20.75 2.73 20.75 3.85L20.75 9.03Z" fill={color} />
    </svg>
  );
}
